<div class="dialog-content-wrapper" cslPerfectScrollbar>
  <mat-toolbar class="mat-accent m-0">
    <mat-toolbar-row class="flex flex-row justify-between items-center flex-1">
      <span i18n class="title dialog-title">Новый паз</span>
      <button mat-button class="mat-icon-button" (click)="dialogRef.close(undefined)" aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  <div mat-dialog-content class="flex flex-row gap-6" fusePerfectScrollbar>
    <form name="grooveForm" [formGroup]="grooveForm" novalidate class="flex flex-col items-stretch basis-64">
      <mat-form-field appearance="outline" class="flex-1">
        <mat-label i18n>Название</mat-label>
        <mat-select formControlName="schema" (selectionChange)="setControls($event.value)">
          <mat-option *ngFor="let item of schemas" [value]="item">
            {{ item.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="flex-1">
        <mat-label i18n>Обозначение</mat-label>
        <input matInput readonly type="text" formControlName="designation" />
      </mat-form-field>

      <mat-form-field
        appearance="outline"
        *ngIf="
          this.grooveType !== thisGrooveTypeEnum.Chamfer &&
          this.grooveType !== thisGrooveTypeEnum.Chamfer2 &&
          this.grooveType !== thisGrooveTypeEnum.Fillet
        ">
        <mat-label><ng-container i18n>Ширина</ng-container> (H)</mat-label>
        <input matInput type="number" formControlName="width" />
        <mat-error i18n *ngIf="grooveForm.get('width').hasError('required')">Поле Ширина не задано</mat-error>
        <mat-error
          i18n
          *ngIf="!grooveForm.get('width').hasError('required') && grooveForm.get('width').hasError('outOfRange')"
          >Значение должно находиться в диапазоне от {{ grooveForm.get('width').getError('outOfRange').min }} до
          {{ grooveForm.get('width').getError('outOfRange').max }}</mat-error
        >
      </mat-form-field>

      <mat-form-field
        appearance="outline"
        *ngIf="
          this.grooveType !== thisGrooveTypeEnum.Chamfer &&
          this.grooveType !== thisGrooveTypeEnum.Chamfer2 &&
          this.grooveType !== thisGrooveTypeEnum.Fillet
        ">
        <mat-label><ng-container i18n>Глубина</ng-container> (G)</mat-label>
        <input matInput type="number" formControlName="depth" />
        <mat-error i18n *ngIf="grooveForm.get('depth').hasError('required')">Поле Глубина не задано</mat-error>
        <mat-error
          i18n
          *ngIf="!grooveForm.get('depth').hasError('required') && grooveForm.get('depth').hasError('outOfRange')"
          >Значение должно находиться в диапазоне от {{ grooveForm.get('depth').getError('outOfRange').min }} до
          {{ grooveForm.get('depth').getError('outOfRange').max }}</mat-error
        >
      </mat-form-field>

      <mat-form-field appearance="outline" *ngIf="this.grooveType === thisGrooveTypeEnum.Chamfer2">
        <mat-label><ng-container i18n>Смещение</ng-container> (B)</mat-label>
        <input matInput type="number" formControlName="bShift" />
        <mat-error i18n *ngIf="grooveForm.get('bShift').hasError('required')">Поле Смещение не задано</mat-error>
        <mat-error
          i18n
          *ngIf="!grooveForm.get('bShift').hasError('required') && grooveForm.get('bShift').hasError('outOfRange')"
          >Значение должно находиться в диапазоне от {{ grooveForm.get('bShift').getError('outOfRange').min }} до
          {{ grooveForm.get('bShift').getError('outOfRange').max }}</mat-error
        >
      </mat-form-field>

      <mat-form-field
        appearance="outline"
        *ngIf="
          this.grooveType === thisGrooveTypeEnum.InPlate ||
          this.grooveType === thisGrooveTypeEnum.InSide ||
          this.grooveType === thisGrooveTypeEnum.Chamfer2
        ">
        <mat-label><ng-container i18n>Смещение</ng-container> (dx)</mat-label>
        <input matInput type="number" formControlName="shift" />
        <mat-error i18n *ngIf="grooveForm.get('shift').hasError('required')">Поле Смещение не задано</mat-error>
        <mat-error
          i18n
          *ngIf="!grooveForm.get('shift').hasError('required') && grooveForm.get('shift').hasError('outOfRange')"
          >Значение должно находиться в диапазоне от {{ grooveForm.get('shift').getError('outOfRange').min }} до
          {{ grooveForm.get('shift').getError('outOfRange').max }}</mat-error
        >
      </mat-form-field>

      <mat-form-field appearance="outline" *ngIf="this.grooveType === thisGrooveTypeEnum.Fillet">
        <mat-label><ng-container i18n>Радиус</ng-container> (R)</mat-label>
        <input matInput type="number" formControlName="radius" />
        <mat-error i18n *ngIf="grooveForm.get('radius').hasError('required')">Поле Радиус не задано</mat-error>
        <mat-error
          i18n
          *ngIf="!grooveForm.get('radius').hasError('required') && grooveForm.get('radius').hasError('outOfRange')"
          >Значение должно находиться в диапазоне от {{ grooveForm.get('radius').getError('outOfRange').min }} до
          {{ grooveForm.get('radius').getError('outOfRange').max }}</mat-error
        >
      </mat-form-field>

      <mat-form-field appearance="outline" *ngIf="this.grooveType === thisGrooveTypeEnum.Chamfer">
        <mat-label><ng-container i18n>Угол</ng-container> (Fi)</mat-label>
        <input matInput type="number" formControlName="angle" />
        <mat-error i18n *ngIf="grooveForm.get('angle').hasError('required')">Поле Угол не задано</mat-error>
        <mat-error
          i18n
          *ngIf="!grooveForm.get('angle').hasError('required') && grooveForm.get('angle').hasError('outOfRange')"
          >Значение должно находиться в диапазоне от {{ grooveForm.get('angle').getError('outOfRange').min }} до
          {{ grooveForm.get('angle').getError('outOfRange').max }}</mat-error
        >
      </mat-form-field>
    </form>

    <div class="flex flex-row justify-center items-center basis-2/1" [ngSwitch]="grooveType">
      <ng-container *ngSwitchCase="thisGrooveTypeEnum.InPlate">
        <img class="slot-schema" src="/assets/images/grooves/in-plate.svg" alt="Паз в пласти" />
      </ng-container>
      <ng-container *ngSwitchCase="thisGrooveTypeEnum.InSide">
        <img class="slot-schema" src="/assets/images/grooves/in-side.svg" alt="Паз в торце" />
      </ng-container>
      <ng-container *ngSwitchCase="thisGrooveTypeEnum.Rabbet">
        <img class="slot-schema" src="/assets/images/grooves/rabbet.svg" alt="Четверть" />
      </ng-container>
      <ng-container *ngSwitchCase="thisGrooveTypeEnum.Chamfer">
        <img class="slot-schema" src="/assets/images/grooves/chamfer.svg" alt="Срез" />
      </ng-container>
      <ng-container *ngSwitchCase="thisGrooveTypeEnum.Fillet">
        <img class="slot-schema" src="/assets/images/grooves/fillet.svg" alt="Фаска скругленная" />
      </ng-container>
      <ng-container *ngSwitchCase="thisGrooveTypeEnum.Chamfer2">
        <img class="slot-schema" src="/assets/images/grooves/chamfer2.svg" alt="Фаска" />
      </ng-container>
    </div>
  </div>

  <mat-divider></mat-divider>

  <div mat-dialog-actions>
    <button i18n mat-raised-button class="mat-accent mr-4" (click)="saveAndClose()" [disabled]="grooveForm.invalid"
      >ОК</button
    >
    <button i18n mat-button (click)="dialogRef.close(undefined)">ОТМЕНА</button>
  </div>
</div>
